<template>
  <div id="inventory">
      <STARInventoryTable :username="user" v-if="user && table === 'STAR'"/>
      <CROPInventoryTable :username="user" v-else-if="user && table === 'DCROPS'"/>
      <v-card v-else>
        The selected inventory view is (currently) not supported
      </v-card>
  </div>
</template>

<script>
import STARInventoryTable from "../components/tables/inventory/STAR";
import CROPInventoryTable from "../components/tables/inventory/DCROPS";

export default {
  name: 'Inventory',
  components: {STARInventoryTable, CROPInventoryTable},
  mounted() {
    this.user = this.$route.params.username;
    this.table = this.$route.params.table;
  },
  data() {
    return {
      user: null,
      table: "STAR"
    }
  },
  methods: {
  }
}
</script>

<style scoped>
#inventory {
  margin: 10px;
}
</style>